import { environment } from 'src/app/enviroments/enviroment';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SpinnerService } from './services/spinner.service';
import { DataService } from './services/data.service';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Observable, combineLatest, filter, map } from 'rxjs';
import { CrediflowLayoutComponent } from './layouts/crediflow-layout/crediflow-layout.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ErrorModalComponent } from './shared/error-modal/error-modal.component';
import { CommonModule } from '@angular/common';
import { Location } from '@angular/common';
import { IIPLookupServiceToken } from './interfaces/ip-lookup-service.interface';
import { IpinfoService } from './services/ip-lookup/ip-info.service';
import { IpLookUpManagerService } from './services/ip-lookup/ip-lookup-manager.service';
import { SecureStorageService } from './services/secure-storage.service';
import { SessionService } from './services/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CommonModule, CrediflowLayoutComponent, RouterOutlet, NgxSpinnerModule, ErrorModalComponent],
  standalone: true,
  providers: [{ provide: IIPLookupServiceToken, multi: true, useClass: IpinfoService }, IpLookUpManagerService],
})
export class AppComponent implements OnInit {
  static componentName = 'AppComponent';
  static componentDescription =
    'Componente raíz de la aplicación que gestiona la inicialización de sesión, enrutamiento y estado global de la app';

  ngOnInit(): void {
    this.ipLookupService
      .getIp()
      .then((ip) => this.dataService.setIp(ip))
      .catch(() => {});
  }

  public imageTemplate = '';
  public spinnerText$ = this.spinner.getSpinnerObservable();
  public encryptedToken = '';
  public isGiveawayActive$ = this.isGiveawayActiveSimulatorScreen$();

  get isFirstScreen$(): Observable<boolean> {
    return this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => {
        const url = this.router.url;
        const segments = url.split('/');
        return segments[segments.length - 1];
      }),
      map((url) => url.includes('home')),
    );
  }

  constructor(
    private spinner: SpinnerService,
    private dataService: DataService,
    private router: Router,
    private location: Location,
    private ipLookupService: IpLookUpManagerService,
    private secureStorage: SecureStorageService,
    private sessionService: SessionService,
  ) {
    this.detectBrowserBackNavigation();
  }

  @ViewChild('loadingImage', { static: true }) set loadingImage(image: ElementRef<HTMLImageElement>) {
    this.imageTemplate = image.nativeElement.outerHTML;
    image.nativeElement.style.display = 'none';
  }

  private detectBrowserBackNavigation(): void {
    this.location.subscribe((event) => {
      if (event.type === 'popstate') {
        window.location.href = window.location.origin + '/';
        this.clearCurrentSession();
      }
    });
  }

  private clearCurrentSession(): void {
    this.secureStorage.storeEncrypted(environment.loggedTokenKey, null);
    this.secureStorage.storeEncrypted(environment.loggedData, null);
    this.secureStorage.storeEncrypted(environment.loggedTokenKey, null);
    this.sessionService.clearSession();
  }

  private isGiveawayActiveSimulatorScreen$(): Observable<boolean> {
    return combineLatest([this.dataService.getIsGiveawayActive$(), this.isFirstScreen$]).pipe(
      map(([active, firstScreen]) => active && firstScreen),
    );
  }
}
